import React from "react";
export const ScheduleLoadingState = () => {
  return <div className="space-y-8 animate-pulse">
      {/* Day selector loading */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[...Array(3)].map((_, i) => <div key={i} className="h-24 bg-gray-200 rounded-lg w-full" />)}
      </div>
      {/* Sessions loading */}
      <div className="space-y-6">
        {[...Array(3)].map((_, timeSlot) => <div key={timeSlot} className="space-y-2">
            <div className="w-20 h-4 bg-gray-200 rounded" />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {[...Array(3)].map((_, session) => <div key={session} className="h-32 bg-gray-200 rounded-lg w-full" />)}
            </div>
          </div>)}
      </div>
    </div>;
};